import React, { Component } from 'react';

class Column extends Component {

  render() {
    return (
      <td className="border-b px-4 py-3">
        {this.props.children}
      </td>
    );
  }

}

export default Column;
